import { useRSStore } from '@/store/useRSStore'
import { useUserStore } from '@/store/useUserStore'
import { updateConfigAPI, readUserListAPI, addUserAPI, updateUserAPI, deleteUserAPI } from '../api/UserAPI'
import type { config } from '../types/types'

export function useUser() {
  const RSStore = useRSStore()
  const UserStore = useUserStore()
  const onUpdateUserConfig = async (username: string, config: config) => {
    try {
      const result = await updateConfigAPI(username, config)
      if (result) {
        UserStore.itemPerPage = config.tablesize
        UserStore.siblingCount = config.pnbtncount
        console.log("사용자 설정 업데이트 성공:", result)
      }
    } catch (e) {
      console.error("사용자 설정 업데이트 중 에러 발생:", e)
    }
  }

  const onReadUserList = async () => {
    try {
      const result = await readUserListAPI()
      RSStore.userList = result
      console.log("사용자 목록 불러오기 성공:", RSStore.userList)
    } catch (e) {
      console.error("사용자 목록 불러오기 중 에러 발생:", e)
    }
  }
  const onAddUser = async (account: string, password: string, description: string, role: number) => {
    try {
     
      const defaultConfig: config = { tablesize: 20, pnbtncount: 3 }
      const result = await addUserAPI(account, password, description, role, defaultConfig)
      if (result === 'duplicate') {
        return 'duplicate'
      }
      console.log("사용자 추가 완료 id:", result)
      onReadUserList() // 추가 후 사용자 목록 새로고침
    } catch (e) {
      console.error("사용자 추가 중 에러 발생:", e)
    }
  }

  const onUpdateUser = async (existingAccount: string, account: string, password: string, description: string, role: number) => {
    try {
      const result = await updateUserAPI(existingAccount, account, password, description, role)
      if (result) {
        console.log("사용자 업데이트 완료 :", account)
        onReadUserList() // 업데이트 후 사용자 목록 새로고침
      } else {
        console.error("사용자 업데이트 실패 입력값 확인 필요:", account)
      }
    } catch (e) {
      console.error("사용자 업데이트 중 에러 발생:", e)
    }
  }
    const onDeleteUser = async (account: string) => {
      try {
        const result = await deleteUserAPI(account)
        if (result) {
          console.log("사용자 삭제 성공:", account)
          onReadUserList() // 삭제 후 사용자 목록 새로고침
        }
      } catch (e) {
        console.error("사용자 삭제 중 에러 발생:", e)
      }
    }
  

    return { onUpdateUserConfig, onReadUserList, onDeleteUser, onAddUser, onUpdateUser }
}
